"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _mdbreact = require("mdbreact");

var _reactRouterDom = require("react-router-dom");

require("@fortawesome/fontawesome-free/css/all.min.css");

require("bootstrap-css-only/css/bootstrap.min.css");

require("./mdb/css/mdb.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var F1HeaderNav = /*#__PURE__*/function (_React$Component) {
  _inherits(F1HeaderNav, _React$Component);

  var _super = _createSuper(F1HeaderNav);

  function F1HeaderNav(props) {
    var _this;

    _classCallCheck(this, F1HeaderNav);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onClickHadndler", function (event, item, child_item) {
      if (item.href === '' || item.href === '#') {
        event.preventDefault();
      }

      _this.props.config.onItemClick(item, child_item);
    });

    _this.state = {
      collapse: false
    };
    _this.onClick = _this.onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(F1HeaderNav, [{
    key: "onClick",
    value: function onClick() {
      this.setState({
        collapse: !this.state.collapse
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          config = _this$props.config,
          brandComponent = _this$props.brandComponent;
      return /*#__PURE__*/_react.default.createElement(_reactRouterDom.BrowserRouter, null, /*#__PURE__*/_react.default.createElement("header", null, /*#__PURE__*/_react.default.createElement(_mdbreact.MDBNavbar, {
        className: config.navBarClassName,
        style: config.navBarStyle,
        dark: true,
        expand: "md",
        scrolling: true,
        fixed: "top"
      }, config.brandType && config.brandType === 'image' ? /*#__PURE__*/_react.default.createElement("img", {
        alt: "",
        src: config.brandImgUrl,
        className: config.brandClass,
        style: config.brandStyle
      }) : config.brandType === 'component' ? /*#__PURE__*/_react.default.createElement("div", {
        className: config.brandClass,
        style: config.brandStyle
      }, brandComponent) : config.brandType === 'text' ? /*#__PURE__*/_react.default.createElement(_mdbreact.MDBNavbarBrand, {
        className: config.brandClass,
        style: config.brandStyle,
        href: config.brandLink
      }, /*#__PURE__*/_react.default.createElement("strong", null, config.brandText)) : '', /*#__PURE__*/_react.default.createElement(_mdbreact.MDBNavbarToggler, {
        onClick: this.onClick
      }), /*#__PURE__*/_react.default.createElement(_mdbreact.MDBCollapse, {
        id: "navbarCollapse3",
        isOpen: this.state.collapse,
        navbar: true
      }, /*#__PURE__*/_react.default.createElement(_mdbreact.MDBNavbarNav, {
        left: true
      }, config.menus.left && config.menus.left.map(function (item, index) {
        if (item.type === 'link') {
          if (!item.hide) {
            if (item.onItemRender) {
              return item.onItemRender(item);
            } else {
              return /*#__PURE__*/_react.default.createElement(_mdbreact.MDBNavItem, {
                className: item.className,
                active: item.is_active,
                key: index
              }, /*#__PURE__*/_react.default.createElement(_mdbreact.MDBNavLink, {
                link: true,
                onClick: function onClick(event) {
                  return _this2.onClickHadndler(event, item);
                },
                to: item.href
              }, item.icon ? /*#__PURE__*/_react.default.createElement(_mdbreact.MDBIcon, {
                icon: item.icon
              }) : '', item.label));
            }
          }
        } else {
          if (!item.hide) {
            return /*#__PURE__*/_react.default.createElement(_mdbreact.MDBNavItem, {
              key: index,
              className: item.className,
              active: item.is_active
            }, /*#__PURE__*/_react.default.createElement(_mdbreact.MDBDropdown, null, /*#__PURE__*/_react.default.createElement(_mdbreact.MDBDropdownToggle, {
              nav: true,
              caret: true
            }, item.label ? /*#__PURE__*/_react.default.createElement("div", {
              className: "d-none d-md-inline"
            }, item.label) : '', item.icon ? /*#__PURE__*/_react.default.createElement(_mdbreact.MDBIcon, {
              icon: item.icon
            }) : ''), /*#__PURE__*/_react.default.createElement(_mdbreact.MDBDropdownMenu, {
              className: "dropdown-default"
            }, item.childs.map(function (child_item, index) {
              if (!child_item.hide) {
                return /*#__PURE__*/_react.default.createElement(_mdbreact.MDBDropdownItem, {
                  onClick: function onClick(event) {
                    return _this2.onClickHadndler(event, item, child_item);
                  },
                  className: child_item.className,
                  key: index,
                  href: child_item.href
                }, child_item.icon ? /*#__PURE__*/_react.default.createElement(_mdbreact.MDBIcon, {
                  icon: child_item.icon
                }) : '', child_item.label);
              }
            }))));
          }
        }
      })), /*#__PURE__*/_react.default.createElement(_mdbreact.MDBNavbarNav, {
        right: true
      }, this.props.customComponent, config.menus.right && config.menus.right.map(function (item, index) {
        if (item.type === 'link') {
          if (!item.hide) {
            if (item.onItemRender) {
              return item.onItemRender(item);
            } else {
              return /*#__PURE__*/_react.default.createElement(_mdbreact.MDBNavItem, {
                className: item.className,
                active: item.is_active,
                key: index
              }, /*#__PURE__*/_react.default.createElement(_mdbreact.MDBNavLink, {
                link: true,
                onClick: function onClick(event) {
                  return _this2.onClickHadndler(event, item);
                },
                to: item.href
              }, item.icon ? /*#__PURE__*/_react.default.createElement(_mdbreact.MDBIcon, {
                icon: item.icon
              }) : '', item.label));
            }
          }
        } else {
          if (!item.hide) {
            return /*#__PURE__*/_react.default.createElement(_mdbreact.MDBNavItem, {
              key: index,
              className: item.className,
              active: item.is_active
            }, /*#__PURE__*/_react.default.createElement(_mdbreact.MDBDropdown, null, /*#__PURE__*/_react.default.createElement(_mdbreact.MDBDropdownToggle, {
              nav: true,
              caret: true
            }, item.label ? /*#__PURE__*/_react.default.createElement("div", {
              className: "d-none d-md-inline"
            }, item.label) : '', item.icon ? /*#__PURE__*/_react.default.createElement(_mdbreact.MDBIcon, {
              icon: item.icon
            }) : ''), /*#__PURE__*/_react.default.createElement(_mdbreact.MDBDropdownMenu, {
              className: "dropdown-default"
            }, item.childs.map(function (child_item, index) {
              if (!child_item.hide) {
                return /*#__PURE__*/_react.default.createElement(_mdbreact.MDBDropdownItem, {
                  onClick: function onClick(event) {
                    return _this2.onClickHadndler(event, item, child_item);
                  },
                  className: child_item.className,
                  key: index,
                  href: child_item.href
                }, child_item.icon ? /*#__PURE__*/_react.default.createElement(_mdbreact.MDBIcon, {
                  icon: child_item.icon
                }) : '', child_item.label);
              }
            }))));
          }
        }
      })), config.menus.others ? /*#__PURE__*/_react.default.createElement(_mdbreact.MDBNavbarNav, {
        left: true,
        className: "nav-bar-ohters"
      }, config.menus.others && config.menus.others.map(function (item, index) {
        if (item.type === 'link') {
          if (!item.hide) {
            return /*#__PURE__*/_react.default.createElement(_mdbreact.MDBNavItem, {
              className: item.className,
              active: item.is_active,
              key: index
            }, /*#__PURE__*/_react.default.createElement(_mdbreact.MDBNavLink, {
              link: true,
              onClick: function onClick(event) {
                return _this2.onClickHadndler(event, item);
              },
              to: item.href
            }, item.label));
          }
        } else {
          if (!item.hide) {
            return /*#__PURE__*/_react.default.createElement(_mdbreact.MDBNavItem, {
              key: index,
              className: item.className,
              active: item.is_active
            }, /*#__PURE__*/_react.default.createElement(_mdbreact.MDBDropdown, null, /*#__PURE__*/_react.default.createElement(_mdbreact.MDBDropdownToggle, {
              nav: true,
              caret: true
            }, item.label ? /*#__PURE__*/_react.default.createElement("div", {
              className: "d-none d-md-inline"
            }, item.label) : '', item.icon ? /*#__PURE__*/_react.default.createElement(_mdbreact.MDBIcon, {
              icon: item.icon
            }) : ''), /*#__PURE__*/_react.default.createElement(_mdbreact.MDBDropdownMenu, {
              className: "dropdown-default"
            }, item.childs.map(function (child_item, index) {
              if (!child_item.hide) {
                return /*#__PURE__*/_react.default.createElement(_mdbreact.MDBDropdownItem, {
                  onClick: function onClick(event) {
                    return _this2.onClickHadndler(event, item, child_item);
                  },
                  className: child_item.className,
                  key: index,
                  href: child_item.href
                }, child_item.icon ? /*#__PURE__*/_react.default.createElement(_mdbreact.MDBIcon, {
                  icon: child_item.icon
                }) : '', child_item.label);
              }
            }))));
          }
        }
      })) : ''))));
    }
  }]);

  return F1HeaderNav;
}(_react.default.Component);

var _default = F1HeaderNav;
exports.default = _default;